export default __webpack_public_path__ + "static/media/site-vitrine.ecb9a75c.svg";